import { TransactionType } from '../../extract/extract.model';
import { ETipoOperacao } from './qr-code-return.model';
import { OperationType } from './transaction.model';

export class PixTransferReturn {
	falha: Falha;
	mensagem: string;
	sucesso: PixTransferReturnSucesso;
	sequencial: number;
	situacaoTransferencia: PixTransferReturnSituacaoTransferencia;
}

export class Falha {
	complemento: string;
	descricao: string;
	codigo: string;
}

export class TransacaoBoleto {
	agencia: number;
	codigoBarras: string;
	documento: string;
	nome: string;
}

export class TransacaoCartaoDebito {
	categoriaEstabelecimento: string;
	cidadeEstabelecimento: string;
	paisEstabelecimento: string;
	nomeEstabelecimento: string;
}

export class TransacaoOriginal {
	descricao: string;
	codigoTransacaoQrCode: string;
	valor: number;
	dataTransacao: Date;
}

export class TransacaoPix {
	numeroConta: string;
	tipoConta: string;
	agencia: number;
	autenticacao: string;
	complemento: string;
	documento: string;
	codigoFimAFim: string;
	codigoFimAFimDevolucao: string;
	codigoISPB: string;
	nomeISPB: string;
	nome: string;
	codigoTransacaoQrCode: string;
	transacaoOriginal: TransacaoOriginal;
	tipoOperacao: OperationType;
	valores: TransacaoPixValores;
}

export class TransacaoTransferencia {
	numeroConta: number;
	agencia: number;
	autenticacao: string;
	codigoBanco: number;
	complemento: string;
	documento: string;
	codigoISPB: string;
	nomeISPB: string;
	nome: string;
}

export class PixTransferReturnSucesso {
	dataContabil: Date;
	tipoMovimentacao: string;
	transacaoBoleto: TransacaoBoleto;
	dataTransacao: Date;
	transacaoCartaoDebito: TransacaoCartaoDebito;
	transacaoPix: TransacaoPix;
	codigoTransacao: number;
	transacaoTransferencia: TransacaoTransferencia;
	tipoTransacao: TransactionType;
	valor: number;
}

export interface TransacaoPixValores {
	desconto: number;
	multa: number;
	juros: number;
	original: number;
	abatimento: number;
	valorRetirada: number;
	valorTroco: number;
	valorVenda: number;
}

export enum PixTransferReturnSituacaoTransferencia {
	AGUARDANDO_AUTORIZACAO = 'AGUARDANDO_AUTORIZACAO', // Transferência digitada e pendente de aprovação
	AUTORIZADA_AGUARDANDO_EFETIVACAO = 'AUTORIZADA_AGUARDANDO_EFETIVACAO', // Transferência autorizada pelo correntista e pendente de efetivação // pagamento agendado
	TRANSFERENCIA_REALIZADA = 'TRANSFERENCIA_REALIZADA', // Transferência Realizada
	TRANSFERENCIA_REPROVADA = 'TRANSFERENCIA_REPROVADA', // Transferência reprovada pelo Titular da conta
	TRANSFERENCIA_EXPIRADA = 'TRANSFERENCIA_EXPIRADA', // Quando uma transferência agendada não foi autorizada e expirou
	ERRO_TRANSFERENCIA = 'ERRO_TRANSFERENCIA', // Erro no curso do processamento da Transferência
	PENDENTE_DEMAIS_APROVACOES = 'PENDENTE_DEMAIS_APROVACOES', // Transferência autorizada e pendente de demais aprovações
	AGUARDANDO_CONFIRMACAO_IF_DESTINO = 'AGUARDANDO_CONFIRMACAO_IF_DESTINO', // Transferência PIX enviada e aguarda IF Destino
	REJEITADA_IF_DESTINO = 'REJEITADA_IF_DESTINO', // Transferência rejeitada por outra IF (PIX)
	CANCELADA_TESOURARIA = 'CANCELADA_TESOURARIA', // Transferência cancelada na Tesouraria
	CANCELADA_CLIENTE = 'CANCELADA_CLIENTE',// Transferência cancelada pelo Cliente (Desfazimento)
	AGUARDANDO_ANALISE_ANTIFRAUDE = 'AGUARDANDO_ANALISE_ANTIFRAUDE',
	CANCELADA_SUSPEITA_FRAUDE = 'CANCELADA_SUSPEITA_FRAUDE'
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/models/transfer-return.model.ts